<template>
  <div class="component-update-price">
    <el-button @click="handleOpen" :loading="loading" type="text">快速修改<i class="el-icon-arrow-right el-icon--right" /></el-button>

    <el-dialog custom-class="dialog-update-price" destroy-on-close :visible="visible" :title="`快速修改-${product.name}`" append-to-body fullscreen @close="handleClose">
      <div class="dialog-header">
        <el-form>
          <el-form-item label="修改分类">
            <c-select
              class="select-category"
              v-model="form.category_ids"
              multiple
              clearable
              filterable
              :options="categories"
            />
          </el-form-item>
        </el-form>

        <el-form inline>
          <el-form-item label="批量修改">
          </el-form-item>
          <el-form-item label="售价(元)">
            <el-input @input="handleBatchUpdate('sale_price', $event)" v-model="batchUpdateForm.sale_price"></el-input>
          </el-form-item>
          <el-form-item label="折扣价(元)">
            <el-input @input="handleBatchUpdate('discount_price', $event)" v-model="batchUpdateForm.discount_price"></el-input>
          </el-form-item>
          <el-form-item label="员工价(元)">
            <el-input @input="handleBatchUpdate('employee_price', $event)" v-model="batchUpdateForm.employee_price"></el-input>
          </el-form-item>
          <el-form-item label="佣金(元)">
            <el-input @input="handleBatchUpdate('commission', $event)" v-model="batchUpdateForm.commission"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="dialog-content">
        <c-source-table
          :columns="tableColumns"
          :table="{ data: data, border: true }"
        />
      </div>
      <div class="dialog-button">
        <el-button size="medium" type="primary" @click="handleSave" :loading="saving">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
  import { Vue, Component, Prop } from 'vue-property-decorator';

  @Component
  export default class UpdatePrice extends Vue {
    @Prop(Object) product;

    visible = false;
    loading = false;
    saving = false;
    data = [];
    categories = [];
    batchUpdateForm = {};

    form = {
      category_ids: []
    };

    tableColumns = [
      {
        prop: 'sku_id',
        label: 'SKU编码',
        width: 100,
      },
      {
        prop: 'display_name',
        width: 160,
        label: '商品名'
      },
      {
        prop: 'sale_price',
        label: '售价(元)',
        renderCell: (h, { row, $index }) => this.renderTableFormItem({ row, $index, prop: 'sale_price' })
      },
      {
        prop: 'discount_price',
        label: '折扣价(元)',
        renderCell: (h, { row, $index }) => this.renderTableFormItem({ row, $index, prop: 'discount_price' })
      },
      {
        prop: 'employee_price',
        label: '员工价(元)',
        renderCell: (h, { row, $index }) => this.renderTableFormItem({ row, $index, prop: 'employee_price' })
      },
      {
        prop: 'commission',
        label: '佣金(元)',
        renderCell: (h, { row, $index }) => this.renderTableFormItem({ row, $index, prop: 'commission' })
      },
      {
        prop: 'qty',
        width: 100,
        label: '库存数量(件)'
      }
    ]

    async fetchData() {
      this.loading = true;
      try {
        const [{ data }, { data: categories }] = await Promise.all([
          this.$request.get(`/products/${this.product.id}/goodses`, { per_page: 100 }, { loading: false }),
          this.$request.get('/categories', { per_page: 100, simple_list: true }, { loading: false })
        ])
        this.form.category_ids = this.product.categories.map(item => item.id);
        this.data = data;
        this.categories = categories.map(item => ({
          label: item.name,
          options: item.children.map(child => ({ value: child.id, label: child.name }))
        }))
      } finally {
        this.loading = false;
      }
    }

    renderTableFormItem({ row, $index, prop, component = 'input' } = {}) {
      return <c-source-form-item
        in-form={false}
        column={{
          prop,
          form: {
            component
          }
        }}
        value={row}
        onChange={(data) => this.handleChange($index, prop, data[prop])}
      />
    }

    async handleOpen() {
      await this.fetchData();
      this.visible = true;
    }

    handleClose() {
      this.visible = false;
    }

    handleChange(index, prop, value) {
      this.$set(this.data[index], prop, value);
    }

    handleBatchUpdate(prop, value) {
      this.data.forEach(item => this.$set(item, prop, value))
    }

    async handleSave() {
      const body = {
        ...this.form,
        category_ids: this.form.category_ids.join(','),
        goodses_attributes: this.data.map(item => ({
          id: item.id,
          sale_price: item.sale_price,
          discount_price: item.discount_price,
          employee_price: item.employee_price,
          commission: item.commission
        }))
      }
      try {
        this.saving = true;
        await this.$request.put(`/products/${this.product.id}/quickly_update`, body, { loading: false });
        this.$message.success('修改成功');
        this.handleClose();
        this.$emit('success');
      } finally {
        this.saving = false;
      }
    }
  }
</script>

<style lang="scss">
  .dialog-update-price {
    display: flex;
    flex-direction: column;

    .el-dialog__body {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
  }
</style>

<style lang="scss" scoped>
  .select-category {
    width: 500px;
  }

  .dialog-header,
  .dialog-button {
    flex-shrink: 0;
  }

  .dialog-content {
    flex: 1;
    overflow: hidden;
  }

  .c-source-table {
    height: 100%;
  }

  .dialog-button {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
  }
</style>
